import { PartnerDashboardView } from "@/components/partner/PartnerViews";

const PartnerDashboard = () => <PartnerDashboardView />;

export default PartnerDashboard;
